

























import {Vue, Component, Watch} from 'vue-property-decorator';
import { ITagView, TagsViewModule } from '@/store/modules/tagsView';
import { RouteConfig } from 'vue-router';
import { PermissionModule } from '@/store/modules/permission';
import { pubsub, CLOSE_TAG_VIEW_EVENT } from '@/utils/pubsub';

let closeTagViewEventToken = '';

@Component
export default class TagsView extends Vue {
  private affixTags: ITagView[] = [];
  private visibleMenu: boolean = false;
  private top: number = 0;
  private left: number = 0;
  private selectedTag: ITagView = {};
  get visitedViews() {
    return TagsViewModule.visitedViews;
  }
  get routes() {
    return PermissionModule.routes;
  }
  @Watch('$route')
  private watchRoute() {
    this.addTags();
  }
  @Watch('visibleMenu')
  private watchVisibleMenu(value: boolean) {
    if (value) {
      document.body.addEventListener('click', this.closeMenu);
    } else {
      document.body.removeEventListener('click', this.closeMenu);
    }
  }
  private created() {
    this.bindEvent();
  }
  private destroyed() {
    this.unBindEvent();
  }
  private mounted() {
    this.initTags();
    this.addTags();
  }
  private bindEvent() {
    closeTagViewEventToken = pubsub.subscribe(CLOSE_TAG_VIEW_EVENT, (message: string, data: string) => {
      this.closeTagByPath(data);
    });
  }
  private unBindEvent() {
    pubsub.unsubscribe(closeTagViewEventToken);
  }
  private initTags() {
    this.affixTags = this.filterAffixTags(this.routes);
    for (const tagViews of this.affixTags) {
      if (tagViews.name) {
        TagsViewModule.AddVisitedView(tagViews);
      }
    }
  }
  private addTags() {
    if (this.$route.name) {
      TagsViewModule.AddView(this.$route);
    }
  }
  private filterAffixTags(routes: RouteConfig[]): ITagView[] {
    let tagViews: ITagView[] = [];
    routes.forEach((route) => {
      if (route.meta && route.meta.affix) {
        tagViews.push(route);
      }
      if (route.children) {
        const childTags: ITagView[] = this.filterAffixTags(route.children);
        if (childTags.length >= 1) {
          tagViews = [...tagViews, ...childTags];
        }
      }
    });
    return tagViews;
  }
  private isActive(tagView: ITagView): boolean {
    return tagView.path === this.$route.path;
  }
  private isAffix(tagView: ITagView): boolean {
    return tagView.meta && tagView.meta.affix;
  }
  private toLastView(visitedViews: ITagView[], view: ITagView) {
    const latestView = visitedViews.slice(-1)[0];
    if (latestView && latestView.path) {
      this.$router.push(latestView.path);
    } else {
      this.$router.push('/');
    }
  }
  private openMenu(tagView: ITagView, e: MouseEvent) {
    const menuMinWidth = 200;
    const offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
    const offsetTop = this.$el.getBoundingClientRect().top; // container margin top
    const offsetWidth = (this.$el as HTMLElement).offsetWidth; // container width
    const offsetHeight = (this.$el as HTMLElement).offsetHeight; // container width
    const maxLeft = offsetWidth - menuMinWidth; // left boundary
    const left = e.clientX - offsetLeft;
    const top = e.clientY - (offsetTop + offsetHeight);
    if (left > maxLeft) {
      this.left = maxLeft;
    } else {
      this.left = left;
    }
    this.top = top;
    this.visibleMenu = true;
    this.selectedTag = tagView;
  }
  private closeMenu() {
    this.visibleMenu = false;
  }
  private refreshSelectedTag(tagView: ITagView) {
    TagsViewModule.DelCachedView(tagView);
    this.$router.replace({
      path: '/redirect' + tagView.path,
    });
  }
  private closeSelectedTag(tagView: ITagView) {
    TagsViewModule.DelView(tagView);
    if (this.isActive(tagView)) {
      this.toLastView(TagsViewModule.visitedViews, tagView);
    }
  }
  private closeOthersTags(tagView: ITagView) {
    if (tagView.path && tagView.path !== this.$route.path) {
      this.$router.push(tagView.path);
    }
    TagsViewModule.DelOthersViews(tagView);
  }
  private closeAllTags(tagView: ITagView) {
    TagsViewModule.DelAllViews();
    if (this.affixTags.some((tag) => tag.path === this.$route.path)) {
      return;
    }
    this.toLastView(TagsViewModule.visitedViews, tagView);
  }
  private closeTagByPath(path: string) {
    const result = this.visitedViews.find((tagView) => tagView.path === path);
    if (result) {
      TagsViewModule.DelView(result);
    }
  }
}
